function initMap() {
	const lat = document.getElementById('latitude');
	const lng = document.getElementById('longitude');
	let map;

	if (lat?.value && lng?.value) {
		map = new google.maps.Map(document.getElementById('map'), {
			center: { lat: parseFloat(lat.value), lng: parseFloat(lng.value) },
			zoom: 16,
		});
	}

	class Popup extends google.maps.OverlayView {
		position;
		containerDiv;

		constructor(position, content) {
			super();
			this.position = position;

			content.classList.add('map__popup');

			// This zero-height div is positioned at the bottom of the bubble.
			const bubbleAnchor = document.createElement('div');

			bubbleAnchor.classList.add('map__popup-anchor');
			bubbleAnchor.appendChild(content);

			// This zero-height div is positioned at the bottom of the tip.
			this.containerDiv = document.createElement('div');
			this.containerDiv.classList.add('map__container');
			this.containerDiv.appendChild(bubbleAnchor);

			// Optionally stop clicks, etc., from bubbling up to the map.
			Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
		}

		/** Called when the popup is added to the map. */
		onAdd() {
			this.getPanes().floatPane.appendChild(this.containerDiv);
		}

		/** Called when the popup is removed from the map. */
		onRemove() {
			if (this.containerDiv.parentElement) {
				this.containerDiv.parentElement.removeChild(this.containerDiv);
			}
		}

		/** Called each frame when the popup needs to draw itself. */
		draw() {
			const divPosition = this.getProjection().fromLatLngToDivPixel(
				this.position
			);
			// Hide the popup when it is far out of view.
			const display =
				Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
					? 'block'
					: 'none';

			if (display === 'block') {
				this.containerDiv.style.left = divPosition.x + 'px';
				this.containerDiv.style.top = divPosition.y + 'px';
			}

			if (this.containerDiv.style.display !== display) {
				this.containerDiv.style.display = display;
			}
		}
	}

	const title = document.getElementById('organization-title');

	if (map && lat?.value && lng?.value) {
		const marker = new google.maps.Marker({
			position: new google.maps.LatLng(
				parseFloat(lat.value),
				parseFloat(lng.value)
			),
			icon: app.theme_url + '/img/map-marker.svg',
			map,
			title: title?.value ?? '',
		});

		const popup = new Popup(
			new google.maps.LatLng(
				parseFloat(lat.value) - 0.002,
				parseFloat(lng.value) + 0.008
			),
			document.getElementById('content')
		);
		popup.setMap(map);
	}
}

window.initMap = initMap;
